import React from "react";
import BookingTable from "../../Bookings/BookingTable"; // adjust path

interface TableProps {
  bookings: Booking[];
}

export default function EventReservationTable({ bookings }: TableProps) {
  return (
    <BookingTable bookings={bookings} mode="actions" dateField="createdAt" />
  );
}
